"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const loader_1 = require("../loader");
require("./styles.scss");
const Button = (props) => {
    const { disabled, children, onClick, type = "primary", size = "normal", className = "", loading, tag = "button", buttonUrl, } = props;
    const RootElement = tag === "a" ? (buttonUrl ? react_router_dom_1.Link : "a") : "button";
    let rootProps = {
        className: `c-button c-button--${type} c-button--${size} ${className}`,
        onClick,
        disabled,
    };
    if (tag === "a" && buttonUrl) {
        const clickHandlerPrevented = (event) => {
            if (loading) {
                return;
            }
            event.preventDefault();
            onClick && onClick();
        };
        rootProps = Object.assign(Object.assign({}, rootProps), { to: buttonUrl, onClick: !buttonUrl ? clickHandlerPrevented : undefined });
    }
    return (react_1.default.createElement(RootElement, Object.assign({}, rootProps),
        loading && (react_1.default.createElement("div", { className: "c-button__loader" },
            react_1.default.createElement(loader_1.Loader, { color: type === "primary" ? "white" : "red", scale: 0.5 }))),
        children));
};
exports.Button = Button;
